import { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "./ui/card";
import { useT } from "../lib/i18n";

export default function TechChecklist({ job, disabled }) {
  const t = useT(); const [cl, setCl] = useState(null);
  useEffect(() => { api.get(`/checklists/job/${job.id}`).then((r) => setCl(r.data.checklist)).catch(() => {}); }, [job.id]);
  if (!cl) return null;
  const toggle = async (i) => {
    const next = !i.checked;
    setCl((c) => ({ ...c, items: c.items.map((x) => (x.id === i.id ? { ...x, checked: next } : x)) }));   // anında göster
    try { const r = await api.post(`/checklists/job/${job.id}/toggle`, { item_id: i.id, checked: next }); setCl(r.data.checklist); }
    catch { setCl((c) => ({ ...c, items: c.items.map((x) => (x.id === i.id ? { ...x, checked: !next } : x)) })); }   // başarısızsa geri al
  };
  return (
    <Card className="p-4 border border-slate-200 shadow-none space-y-2" data-testid="tech-checklist">
      <div className="font-semibold text-sm">{t("Kontrol listesi")}: {cl.name}</div>
      {cl.items.map((i) => <label key={i.id} className="flex items-start gap-3 text-sm py-1"><input type="checkbox" className="mt-1 h-5 w-5" disabled={disabled} checked={i.checked} onChange={() => toggle(i)} data-testid="chk-item" /><span className={i.checked ? "line-through text-slate-400" : ""}>{i.text}{i.required && <span className="text-rose-500"> *</span>}</span></label>)}
      <div className="text-[11px] text-slate-400">{t("Zorunlu maddeleri işaretlemeden iş kapatılamaz.")}</div>
    </Card>
  );
}
